"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerModule = void 0;
const router_1 = require("client/components/router");
const ledger_list_1 = require("./modules/ledger-list");
class LedgerModule extends router_1.Router {
    constructor(props) {
        super(props);
        this.addRoute("ledger", /^\/ledger\/?$/, ledger_list_1.LedgerList);
    }
}
exports.LedgerModule = LedgerModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/ledger/ledger.tsx
// module id = 3708
// module chunks = 0